import { IncidentsController } from '../controller/IncidentsController';
import { BaseWidgetWebComponent } from '../../widget/BaseWidgetWebComponent';

export class IncidentsWebComponent extends BaseWidgetWebComponent {
  constructor() {
    super();
    this.initialSetup({
      controllerConstructor: IncidentsController,
    });
  }
}
